import { useCallback, useState } from "react";
import { SubmitHandler } from "react-hook-form";
import { Footer } from "../../components/display/Footer";
import { FullscreenFlexWrapper } from "../../components/display/fullscreen-flex-wrapper";
import { HeadNoMenu } from "../../components/display/HeadNoMenu";
// import { Errors } from "../components/form/errors";
import { ForgotPasswordPageComponent } from "components/auth/forgot-password";
import { tw } from "../../tailwindcss-classnames";
import { useForgotPasswordLazyQuery } from "graphql/generated";

function ForgotPassword() {
  const [errorState, setError] = useState<null | undefined | Error | Error[]>();
  const [successMsg, setSuccessMsg] = useState<null | undefined | string>();

  const [forgotPassword, { loading }] = useForgotPasswordLazyQuery({
    fetchPolicy: "network-only",
    nextFetchPolicy: "standby",
    onCompleted: async (res) => {
      if (res.forgotPassword) {
        setSuccessMsg(
          "Reset password email has been sent to your registered mail account. "
        );
        setTimeout(() => {
          window.location.href = `/login`;
        }, 5000);
      }
    },
    onError: (error) => {
      setError(error);
    },
  });

  const handleSubmit = useCallback<SubmitHandler<{ email: string }>>(
    async (formData, e) => {
      e.preventDefault();
      setError(null);
      try {
        forgotPassword({
          variables: { email: formData.email },
        });
      } catch (error) {
        setError(error);
      }
    },
    []
  );

  return (
    <FullscreenFlexWrapper title="Forgot Password" bg="bg-white">
      <div className={tw("w-full", "flex-1", "flex-shrink-0")}>
        <HeadNoMenu
          heading={"Forgot Password"}
          bg="bg-white"
          className="px-12"
        />
        <ForgotPasswordPageComponent
          onSubmit={handleSubmit}
          error={errorState}
          isLoading={loading}
          successMsg={successMsg}
        />
      </div>
      <Footer className={tw("w-full", "bg-ecru")} />
    </FullscreenFlexWrapper>
  );
}

export default ForgotPassword;
